import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loading = signal(false);

  startLoading(): void {
    this.loading.set(true);
  }

  stopLoading(): void {
    this.loading.set(false);
  }

  isLoading(): boolean {
    return this.loading();
  }
}
